import { render, staticRenderFns } from "./Teachers.vue?vue&type=template&id=f3b2d158&scoped=true&"
import script from "./Teachers.vue?vue&type=script&lang=js&"
export * from "./Teachers.vue?vue&type=script&lang=js&"
import style0 from "./Teachers.vue?vue&type=style&index=0&id=f3b2d158&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3b2d158",
  null
  
)

export default component.exports